import { createContext } from "react";

import type {
  AccountSnapshot,
  LoginValues,
  MessageResponse,
  PreferencesPatch,
  ProfilePatch,
  RegisterValues,
} from "./types";

export interface AccountContextValue {
  account: AccountSnapshot | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (values: LoginValues) => Promise<void>;
  register: (values: RegisterValues) => Promise<MessageResponse>;
  logout: () => Promise<void>;
  refreshAccount: () => Promise<void>;
  updateProfile: (values: ProfilePatch) => Promise<void>;
  updatePreferences: (values: PreferencesPatch) => Promise<void>;
}

export const AccountContext = createContext<AccountContextValue | null>(null);
export const ACCOUNT_QUERY_KEY = ["account", "me"] as const;
